import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "CampaignEditorText CampaignEditorReadOnlyInputBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_ctx.isCampaignCreation)
    ? (_openBlock(), _createBlock(_component_MultiSelect, {
        key: 0,
        ref: "currencyDropdown",
        label: "Currency",
        placeholder: " ",
        class: _normalizeClass([
			'CampaignEditorDropdown',
			{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing }
		]),
        options: _ctx.options,
        onUpdated: _ctx.setCurrency
      }, null, 8 /* PROPS */, ["class", "options", "onUpdated"]))
    : (_ctx.currency)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.currency), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
}